import type {
  LoginData,
  LoginDataMerchant,
  LoginDataAdmin,
  LoginDataManager,
  LoginDataStaff,
  LoginDataOtpSent,
  LoginDataTwoFARequired,
} from './types';

export function isLoginDataMerchant(data: LoginData): data is LoginDataMerchant {
  return 'jwt' in data && 'merchant' in data;
}

export function isLoginDataAdmin(data: LoginData): data is LoginDataAdmin {
  return 'jwt' in data && 'admin' in data;
}

export function isLoginDataManager(data: LoginData): data is LoginDataManager {
  return 'jwt' in data && 'manager' in data;
}

export function isLoginDataStaff(data: LoginData): data is LoginDataStaff {
  return 'jwt' in data && 'staff' in data;
}

export function isLoginDataOtpSent(data: LoginData): data is LoginDataOtpSent {
  return 'otp' in data && 'phone' in data && !('jwt' in data);
}

export function isLoginDataTwoFARequired(data: LoginData): data is LoginDataTwoFARequired {
  return 'requires2FA' in data && data.requires2FA === true && 'twoFactorMethod' in data && 'maskedContact' in data;
}
